<template>
    <vs-row>
        <vs-row @click.native="displayContactModal = false">
            <vs-col vs-lg="3" vs-sm="12" class="p-3">
                <vs-row class="p-5 accountCards">
                    <vs-row vs-justify="space-between">                                                                      
                        <div>
                            <div class="ml-0 pl-0 m-3 ml-3 displayInlineCard font-semibold mt-1" vs-lg="12">{{ details.totalAccounts }}</div>
                            <div class="mt-0 ml-3 mt-3 pb-1 fontS15">Total Accounts</div>
                        </div>
                    </vs-row>
                </vs-row>
            </vs-col>
             <vs-col vs-lg="3" vs-sm="12" class="p-3">
                 <vs-row class="p-5 accountCards">
                    <vs-row vs-justify="space-between" class="cardCircle">
                            <vs-row vs-justify="flex-end">
                                    <vs-dropdown class="selectListCard pt-1" vs-trigger-click>
                                    <vs-row class="a-icon">
                                        Last {{ selectedAccount }} Days
                                        <div class="pt-1 pl-1">
                                            <vs-icon class="" icon="expand_more"></vs-icon>
                                        </div>
                                    </vs-row>

                                    <vs-dropdown-menu>
                                        <vs-dropdown-item @click="setSelectedAccount(7)">
                                        Last 7 Days
                                        </vs-dropdown-item>
                                        <vs-dropdown-item @click="setSelectedAccount(30)">
                                        Last 30 Days
                                        </vs-dropdown-item>
                                        <vs-dropdown-item @click="setSelectedAccount(90)">
                                        Last 90 Days
                                        </vs-dropdown-item>
                                    </vs-dropdown-menu>
                                    </vs-dropdown>
                            </vs-row>
                            <div class="my-1">
                                <vs-row vs-justify="space-between">                                                                    
                                    <div>
                                        <div class="ml-3 displayInlineCard font-semibold" vs-lg="12">{{ details.newAccounts }}</div>
                                        <div class="mt-0 ml-3 mt-2 fontS15">New Accounts</div>
                                    </div>
                                </vs-row>
                            </div>
                    </vs-row>
                </vs-row>
            </vs-col>
            <vs-col vs-lg="3" vs-sm="12" class="p-3">
               <vs-row class="p-5 accountCards">
                    <vs-row vs-justify="space-between">                                                                 
                        <div>
                            <div class="ml-0 pl-0 ml-3 displayInlineCard font-semibold" vs-lg="12">{{ details.totalProfiles }}</div>
                            <div class="mt-0 ml-3 pt-3 pb-1 fontS15">Total Profiles</div>
                        </div>
                    </vs-row>
                </vs-row>
            </vs-col>
            <vs-col vs-lg="3" vs-sm="12" class="p-3">
                 <vs-row class="p-5 accountCards">
                    <vs-row vs-justify="space-between" class="cardCircle">
                            <vs-row vs-justify="flex-end">
                                    <vs-dropdown class="selectListCard pt-1" vs-trigger-click>
                                    <vs-row class="a-icon">
                                        Last {{ selectedProfile }} Days
                                        <div class="pt-1 pl-1">
                                            <vs-icon class="" icon="expand_more"></vs-icon>
                                        </div>
                                    </vs-row>

                                    <vs-dropdown-menu id="adjustDropdown">
                                        <vs-dropdown-item @click="setSelectedProfile(7)">
                                        Last 7 Days
                                        </vs-dropdown-item>
                                        <vs-dropdown-item @click="setSelectedProfile(30)">
                                        Last 30 Days
                                        </vs-dropdown-item>
                                        <vs-dropdown-item @click="setSelectedProfile(90)">
                                        Last 90 Days
                                        </vs-dropdown-item>
                                    </vs-dropdown-menu>
                                    </vs-dropdown>
                            </vs-row>
                            <div class="my-1">
                                <vs-row vs-justify="space-between">                                                                    
                                    <div>
                                        <div class="ml-3 displayInlineCard font-semibold" vs-lg="12">{{ details.newProfiles }}</div>
                                        <div class="mt-0 ml-3 mt-2 fontS15">New Profiles</div>
                                    </div>
                                </vs-row>
                            </div>
                    </vs-row>
                </vs-row>
            </vs-col>
        </vs-row>
        <vs-row vs-justify="space-between" class="my-6 mx-3">
            <vs-dropdown>
              <vs-button  id="bgDarkAction" class="pr-4 font-semibold" type="filled" icon="expand_more" icon-after>Action</vs-button>
              <!-- <a href="#">Hola mundo</a> -->

              <vs-dropdown-menu class="accountsDropdown">
                <vs-dropdown-item :disabled="selected.length <= 0" @click="suspendAccounts(true)">
                  Suspend
                </vs-dropdown-item>
                <vs-dropdown-item :disabled="selected.length <= 0" @click="suspendAccounts(false)">
                  Unsuspend
                </vs-dropdown-item>
                <vs-dropdown-item :disabled="selected.length <= 0" @click="confirmDelete = true">
                  Delete
                </vs-dropdown-item>
              </vs-dropdown-menu>
            </vs-dropdown>
            <input maxLength="30" type="text" name="search" class="search px-4 w-1/4 py-3 shadow-lg" placeholder="Search..." @input="getUserAccounts('search')" v-model="search"/>
            <div class="verticalCenter">
                <vs-button type="filled" @click="exportAsCSV">Export as CSV</vs-button>
            </div>
        </vs-row>
        <vs-row class="tblBgClrAccounts shadow-lg mx-3">
                <vs-table multiple v-model="selected" :max-items="itemsPerPage" :data="accountsList" class="w-full" hoverFlat>
        

                    <template slot="thead">
                        <vs-th sort-key="name">NAME</vs-th>
                        <vs-th sort-key="category">EMAIL</vs-th>
                        <vs-th sort-key="popularity">USER PROFILES</vs-th>
                        <vs-th sort-key="order_status">CREDIT CARDS</vs-th>
                        <vs-th sort-key="order_status">STATUS</vs-th>
                        <vs-th sort-key="order_status">DATE CREATED</vs-th>
                        <vs-th sort-key="order_status"></vs-th>
                    </template>

                    <template slot-scope="{data}">
                    <tbody>
                        <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data" @click.native="displayContactModal = false" >
                            <vs-td @click.native.stop="editData(tr)">
                            <p class="font-medium">{{ tr.firstName+' '+tr.lastName }}</p>
                            </vs-td>

                            <vs-td @click.native.stop="editData(tr)">
                                <p class="font-medium">{{ tr.email }}</p>
                            </vs-td>

                            <vs-td @click.native.stop="editData(tr)">
                                <p class="font-medium pl-6 ml-6">{{ tr.totalProfiles }}</p>
                            </vs-td>

                            <vs-td @click.native.stop="editData(tr)">
                                <p class="font-medium pl-6 ml-6">{{ tr.totalCards }}</p>
                            </vs-td>

                            <vs-td @click.native.stop="editData(tr)">
                                {{ tr.suspended ? 'Suspended' : 'Active' }}
                            </vs-td>

                            <vs-td @click.native.stop="editData(tr)">
                                <p class="font-medium">{{ tr.createdAt | formatLastLogin }}</p>
                            </vs-td>
                             <vs-td @click.native.stop="showingContactModal(tr)">
                                <vs-button>Contact</vs-button>
                            </vs-td>
                        </vs-tr>
                    </tbody>
                    </template>
                </vs-table>
                <vs-row class="my-6 mt-2 pb-4" vs-justify="center" v-if="accountsList && accountsList.length > 0">
                    <div style="width:max-content">
                        <vs-pagination :total="totalPages" v-model="pageIndex" @change="getUserAccounts('pagination')" v-show="accountsListHasData"  @click.native="displayContactModal = false"></vs-pagination>
                    </div>
                </vs-row>
                <vs-popup class="holamundo" title="Status" :active.sync="showDeleteStatus.status">
                 <h5>{{ showDeleteStatus.msg }}</h5>
             </vs-popup>
              <vs-popup class="holamundo" title="Status" :active.sync="showSuspendStatus.status">
                 <h5>{{ showSuspendStatus.msg }}</h5>
             </vs-popup>
             <vs-popup class="holamundo"  title="Status" :active.sync="confirmDelete">
                <h5>Are you sure that you want to delete?</h5>
                <vs-row vs-justify="flex-end">
                    <vs-button @click="deleteAccounts" class="mr-4">Yes</vs-button>
                    <vs-button @click="confirmDelete = false">No</vs-button>
                </vs-row>
            </vs-popup>
        </vs-row>
        <ContactModal :display-contact-modal.sync="displayContactModal" :user="currentUserId" v-if="displayContactModal"/>
    </vs-row>
</template>

<script>
import { MenuIcon } from 'vue-feather-icons';
import { genericErrorMessage, toast } from '@/keys/toast-messages';
import EventBus from '@/event-bus.js';
import ContactModal from '@/components/contact-modal';
import exportFromJSON from "export-from-json";

export default {
    components: {
        MenuIcon,
        ContactModal
    },
    data() {
        return {
            firstRender:false,
            currentUserId: '',
            displayContactModal: false,
            timer: false,
            confirmDelete: false,

            selectedAccount: 7,
            selectedProfile: 7,

            accountsList: [],
            search: '',
            accountsListHasData: true,
            pageIndex: 1,
            totalPages: 1,

            selected: [],
            itemsPerPage: 6,
            isMounted: false,

            selectedRow: false,

            details: {
                totalAccounts: 0,
                newAccounts: 0,
                totalProfiles: 0,
                newProfiles: 0
            },

            showDeleteStatus: {
                msg: '',
                status: false
            },
            showSuspendStatus: {
                msg: '',
                status: false
            },

            toast,
            genericErrorMessage
        }
    },
    methods: {
        showingContactModal(profile){
            this.displayContactModal = false; 
            this.displayContactModal = true;
            this.currentUserId = profile;
        },
        setSelectedAccount(days){
            this.selectedAccount = days;
            this.getNewAccounts();
        },
        setSelectedProfile(days){
            this.selectedProfile = days;
            this.getNewProfiles();
        },
        async suspendAccounts(status){
            let accountIds = [];
            await this.selected.forEach(async function(item, index){
                    accountIds.push(item._id);
                });

            return new Promise((resolve, reject) => {
                this.$axios.patch(this.$ApiKeys.BASE_URL+this.$EndPoints.SuspendAccounts,
                  accountIds, 
                {
                    params:{
                        suspendUsers:status
                    }
                }).then(async res => {
                    if(res.data.success == true){
                        this.showSuspendStatus = {
                            msg: res.data.message,
                            status: true
                        };
                        this.getUserAccounts();
                    } else {
                        this.toast(this.genericErrorMessage());
                    }
                }).catch(e => {
                    if(e.response.data.errors.cardId){
                        this.showDeleteStatus = {
                            msg: e.response.data.errors.cardId,
                            status: true
                        };
                    }
                    else {
                        this.showDeleteStatus = {
                            msg: '',
                            status: false
                        };
                        if(e.response.status !== 401){
                            this.toast(this.genericErrorMessage());
                        }
                    }
                });
            });
        },
        async deleteAccounts(){
            this.confirmDelete = false;
            if(this.selected.length == 0){
                this.showDeleteStatus = {
                    msg: 'Please select atleast one account to delete',
                    status: true
                };
            }
            else {
                this.$vs.loading({
                    background: 'rgba(1,2,3,.2)'
                });
                    this.showDeleteStatus = {
                    msg: '',
                    status: false
                };
                 let accountIds = [];
                await this.selected.forEach(async function(item, index){
                        accountIds.push(item._id);
                });

                return new Promise((resolve, reject) => {
                    this.$axios.delete(this.$ApiKeys.BASE_URL+this.$EndPoints.DeleteAccounts,
                    { 
                        data: accountIds
                    }, 
                    ).then(async res => {
                        this.$vs.loading.close();
                        if(res.data.success == true){
                            this.showDeleteStatus = {
                                msg: res.data.message,
                                status: true
                            };
                            this.getUserAccounts();
                            this.selected = [];
                        } else {
                            this.toast(this.genericErrorMessage());
                        }
                    }).catch(e => {
                        this.$vs.loading.close();
                        if(e.response.data.errors.cardId){
                            this.showDeleteStatus = {
                                msg: e.response.data.errors.cardId,
                                status: true
                            };
                        }
                        else {
                            this.showDeleteStatus = {
                                msg: '',
                                status: false
                            };
                            if(e.response.status !== 401){
                                this.toast(this.genericErrorMessage());
                            }
                        }
                    });
                });
            }
           
        },
         getNewProfiles(){
            return new Promise((resolve, reject) => {
                this.$axios.get(this.$ApiKeys.BASE_URL+this.$EndPoints.DashboardDetails, { 
                   params:{
                        type:'newProfiles',
                        daySpan:this.selectedProfile
                    }
                }).then(async res => {
                    if(res.data.success){
                        resolve(
                            this.details.newProfiles = res.data.data.newProfiles,
                        );
                    } else {
                        this.toast(this.genericErrorMessage());
                    }
                }).catch(e => {
                    if(e.response.status !== 401){
                        this.toast(this.genericErrorMessage());
                    }
                });
            });
        },
         getNewAccounts(){
            return new Promise((resolve, reject) => {
                this.$axios.get(this.$ApiKeys.BASE_URL+this.$EndPoints.DashboardDetails, { 
                   params:{
                        type:'newAccounts',
                        daySpan:this.selectedAccount
                    }
                }).then(async res => {
                    if(res.data.success){
                        resolve(
                            this.details.newAccounts = res.data.data.newAccounts,
                        );
                    } else {
                        this.toast(this.genericErrorMessage());
                    }
                }).catch(e => {
                    if(e.response.status !== 401){
                        this.toast(this.genericErrorMessage());
                    }
                });
            });
        },
        getCardsDetails(){
            return new Promise((resolve, reject) => {
                this.$axios.get(this.$ApiKeys.BASE_URL+this.$EndPoints.DashboardDetails, {
                    headers: {
                        'Authorization': 'bearer '+this.$localStorage.get('token')
                    },
                    params:{
                        type:'allDetails'
                    }
                }).then(async res => {
                    if(res.data.success){
                        resolve(
                            this.details = {
                                totalAccounts: res.data.data.totalAccounts,
                                newAccounts: res.data.data.newAccounts,
                                totalProfiles: res.data.data.totalProfiles,
                                newProfiles: res.data.data.newProfiles
                            }
                        );
                    } else {
                        this.toast(this.genericErrorMessage());
                    }
                }).catch(e => {
                    if(e.response.status !== 401){
                        this.toast(this.genericErrorMessage());
                    }
                    // console.log("Error in getCardDetails: ",e);
                });
            });
        },
        exportAsCSV(){
            return new Promise(async (resolve, reject) => {
                this.$axios.get(
                    this.$ApiKeys.BASE_URL+this.$EndPoints.GetCSV,
                   { headers: {
                        'Authorization': 'bearer '+this.$localStorage.get('token')
                    },
                    params:{userType:'user',populateProfiles:false,exportCsv:true}},
                ).then((response) => {
                    const fileName = 'accounts'
                    const exportType = exportFromJSON.types.csv;
                    const data = response.data.data.data
                     if (data) exportFromJSON({ data, fileName, exportType });
                })
            });
        },
        getUserAccounts(name){
            if(name=='pagination' && this.firstRender==false){
                this.firstRender=true
                return
            }
            this.displayContactModal = false
            clearTimeout(this.timer)
            this.timer = setTimeout(() => {
                this.selected = [];
                this.$vs.loading.close();
                this.$vs.loading({
                    background: 'rgba(1,2,3,.2)'
                });
                return new Promise(async (resolve, reject) => {
                    await this.$axios.get(this.$ApiKeys.BASE_URL+this.$EndPoints.Accounts, { 
                        params: {
                            userType:'user',
                            populateProfiles:true,
                            exportCsv:false,
                            keyword: this.search,
                            page: name == 'search' ? 1 : this.pageIndex,
                            perPage: this.itemsPerPage
                        }
                    }).then(async res => {
                        this.$vs.loading.close();
                        if(res.data.success){
                            if(name == 'search'){
                                this.pageIndex = 1;
                            }
                            if(res.data.data[0].metaData.length<=0 || res.data.data[0].users.length<=0){
                                this.accountsList = [],
                                this.accountsListHasData = false
                            }
                            this.totalPages = Math.ceil(res.data.data[0].metaData[0].total / this.itemsPerPage);
                            resolve(
                                this.accountsList = res.data.data[0].users,
                                this.accountsListHasData = true
                            );
                        } else {
                            this.toast(this.genericErrorMessage());
                        }
                    }).catch(e => {
                        this.$vs.loading.close();
                        if(e.response.status == 404){
                            this.accountsListHasData = false;
                            this.accountsList = [];
                        }
                        if(e.response.status !== 401 && e.response.status !== 404){
                            this.toast(this.genericErrorMessage());
                        }
                    });
                });
            },500)
        },
        editData(data) {
            this.$router.push({name: 'profiles', params: data });
        },
        acceptAlert() {
            this.$vs.notify({
                color: 'primary',
                title: 'Accept Selected',
                text: 'Gingerbread soufflé biscuit oat cake.'
            });
            this.selectedRow = false;
        }
    },
     created() {
        this.getUserAccounts();
        this.getCardsDetails();
        EventBus.$emit('resetToggleGroup',true);
    }
}
</script>

<style> 
   @import './accountsStyle.css';
</style>


